import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getData } from 'features/dinamic';

interface DetalleCicloState {
  status: string;
  error: string;
  detalleCiclo: any | null;
}

const initialState: DetalleCicloState = {
  status: 'idle',
  error: '',
  detalleCiclo: null,
};

export const fetchDetalleCiclo = createAsyncThunk(
  'facilitador/fetchDetalleCiclo',
  async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 143;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

const detalleCicloSlice = createSlice({
  name: 'facilitadorDetalleCiclo',
  initialState,
  reducers: {
    clearDetalleCiclo: (state) => {
      state.detalleCiclo = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchDetalleCiclo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDetalleCiclo.fulfilled, (state, action) => {
        state.status = 'completed';
        state.detalleCiclo = action.payload.data || null;
      })
      .addCase(fetchDetalleCiclo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const selectFacilitadorDetalleCiclo = (state: RootState) => state.facilitadorDetalleCiclo.detalleCiclo;
export const selectFacilitadorDetalleCicloStatus = (state: RootState) => state.facilitadorDetalleCiclo.status;

export const { clearDetalleCiclo } = detalleCicloSlice.actions;

export default detalleCicloSlice.reducer;
